var Marionette = require('marionette');


module.exports = Marionette.ItemView.extend({

    tagName: 'span',

    className: 'ocr_line',

    template: false,//require('./template.hbs'),

    // this is prob small, can put on template instead ?
    // faster in template/not?
    onRender: function() {

        var model = this.model;

        //this.el.id = model.get('page_level_key');
        this.el.id = 'line_' + model.get('id');
        // TODO: would want this linked back to the overall document one
        this.el.setAttribute( 'data-page-zone', model.get('pageLevelZoneId') );
        this.el.setAttribute( 'data-page-line', model.get('page_level_id') );

        // maybe store dpi on the model / parse on init
        this.el.setAttribute( 'style',  model.getBoxCssStyle() );

    }


});

//



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/textLayer/lineLayer/line.js
 ** module id = 445
 ** module chunks = 0
 **/